import { useDispatch } from "react-redux";
import { handleListEbookData, handleListShareAndReciveBooks, handleGetBookByChapter } from "store/books/thunks";
import { useCurrentClass } from "store/classes/selectors";
import { handleGetExtraResource } from "store/extraResource/thunks";
import {
  handleGetBubbleByBook,
  handleListBubbleUserNotes,
} from "store/notes/thunks";
import { handleGetSentenceStarter } from "store/sentenceStarter/thunks";
import { handleGetStudentGroup } from "store/studentGroup/thunks";
import { useCurrentUser } from "store/users/selectors";
import { handleGetWorksheetAssignedClassIds, handleListWorkSheet } from "store/worksheet/thunks";
import { get , find } from "lodash";
import { useClassGameActivity } from "store/one_game/selectors";
import { handleListChapterInteractions } from "store/interactions/thunks";
import { handleTipsBook } from "store/tips/thunks";
import { handleListLessonPlanByBookAndUser } from "store/lesson_plan/thunks";
import { useAllBook } from "store/books/selectors";
import { useClassBooks } from "../books/useClassBooks";
import { handleListActivitiesByIds, handleListChapterActivities } from "store/activities/thunks";
import { handleListChapterQuizzes, handleListQuizzesByIds } from "store/quizzes/thunks";
import { useCollectionWidgets } from "utils/methods/firebaseWidgets";
import { useFirebase } from "containers/FirebaseContext";
import { doc, getDoc } from "firebase/firestore";

const useFetchAllContent = () => {
  const booksAllList = useAllBook();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const { fetchClassGameActivity } = useClassGameActivity();
  const dispatch = useDispatch();
  const { fetchLinkBooks } = useClassBooks();
  const { createCollectionWidgets } = useCollectionWidgets();
  const { firestore } = useFirebase();

  const listChapterData = async (chapter) => {
    dispatch(handleListBubbleUserNotes(currentUser?.id));
    if (chapter) {
      const bubbleData = {
        chapter: chapter,
        classId: currentClass?.id || "",
        userId: currentUser?.id || "",
      };
      dispatch(handleGetBubbleByBook(bubbleData));
      if(currentUser?.role === "teacher"){
      dispatch(
        handleGetSentenceStarter({
          bookId: chapter,
          userId: currentUser.id,
          role: currentUser?.role,
          class_id: currentClass?.id,
        })
      );
      dispatch(handleGetStudentGroup(currentUser?.id));

    }
    
      dispatch(handleGetExtraResource({ bookId: chapter }));
      return dispatch(handleListEbookData(chapter));
    }
  };
  const fetchExternalBookActivitiesAndQuizzes = async (ids) => {
    if(Array.isArray(ids) && ids.length > 0){
    await Promise.allSettled([
      dispatch(handleListActivitiesByIds(ids)),
      dispatch(handleListQuizzesByIds(ids))
    ]);
  }
}
  const fetchEctenalBooks = async (chapter) => {
    if(Array.isArray(booksAllList)){
      const books = find(booksAllList, k => k.id == chapter);
     if(books){
      const ext_books = new Set();
      const { assignmentPlan , lessonPlan , main_book  , workbook_plan   } = books;
      if(Array.isArray(assignmentPlan)){
        assignmentPlan.forEach(k => {
          ext_books.add(parseInt(k.resourceId));
        });
      }
      if(Array.isArray(lessonPlan)){
        lessonPlan.forEach(k => {
          ext_books.add(parseInt(k.resourceId));
        });
      }
      if(Array.isArray(main_book)){
        main_book.forEach(k => {
          ext_books.add(parseInt(k.resourceId));
        });
      }
      if(Array.isArray(workbook_plan)){
        workbook_plan.forEach(k => {
          ext_books.add(parseInt(k.resourceId));
        });
      }
      //find books which are not in the booksAllList
       const ext_books_list = Array.from(ext_books);
       const ext_books_list_not_in_booksAllList = ext_books_list.filter(k => !booksAllList.some(v => v.id == k));
       if (Array.isArray(ext_books_list_not_in_booksAllList) && ext_books_list_not_in_booksAllList.length > 0) {
         fetchExternalBookActivitiesAndQuizzes(ext_books_list_not_in_booksAllList);
         await dispatch(fetchLinkBooks(ext_books_list_not_in_booksAllList));
       }

     }
    }
  }


  const handleUnshareAssignment = async () => {
    try{
      if (get(currentUser, 'role') !== 'teacher' || !currentClass?.id) return;
      const classId = String(currentClass.id);
  
      const docRef = doc(firestore, "share_widgets", classId + "share_assignment");
      const sharedDoc = await getDoc(docRef);
      if (!sharedDoc.exists()) return;
  
      const sharedData = sharedDoc.data() || {};
      if (sharedData?.status !== true) return;
  
      const sharedChapter = sharedData?.data?.chapter ?? sharedData?.chapter;
      const params = new URLSearchParams(window.location.search || "");
      const currentChapter = params.get("chapter") || params.get("id");
  
      if (sharedChapter && currentChapter && String(sharedChapter) === String(currentChapter)) {
          createCollectionWidgets({
            class_id: classId,
            widget_type: 'share_assignment',
            status: true,
            last_active_at: Date.now(),
        });
        return;
      }
  
      createCollectionWidgets({
          class_id: classId,
          widget_type: 'share_assignment',
          status: false,
      });
    }
    catch(error){
      console.log(error, "error in unsharing assignment")
    }
  };
  const fetchWorksheetAssignedClassIds = async (bookId) => {
    try{
      const worksheetAssignedClassIds = await dispatch(handleGetWorksheetAssignedClassIds(currentUser?.id, bookId));
      return worksheetAssignedClassIds;
    }catch(error){
      console.log(error, "error in fetching worksheet assigned class ids")
    }
  }

  const fetchAllContent = async (bookId, pageId) => {
    await Promise.allSettled([
      dispatch(handleGetBookByChapter(bookId)),
      listChapterData(bookId),
      dispatch(
        handleListWorkSheet(
          bookId,
          currentUser?.role,
          currentUser?.role === "student"
            ? currentClass?.teacherId
            : get(currentUser, "id"),
          null,
          null,
          null,
          currentClass?.id
        )
      ),
      fetchClassGameActivity(),
      dispatch(handleListChapterInteractions(bookId)),
      dispatch(handleTipsBook(bookId)),
      dispatch(handleListLessonPlanByBookAndUser(bookId,currentUser?.id)),
      dispatch(handleListChapterActivities(bookId)),
      dispatch(handleListChapterQuizzes(bookId)),
      fetchEctenalBooks(bookId),
      handleUnshareAssignment(),
      fetchWorksheetAssignedClassIds(bookId)
    ]);
  };

  return { fetchAllContent };
};

export default useFetchAllContent;
